import {
  Location,
  Operations,
} from "../../bookmydesk-api-sdk-typescript-axios";

export const kLocations: (Location & Operations)[] = [
  {
    id: "00000011-0000-4000-a000-000000000004",
    name: "Head Office",
    bookingLimit: -1,
    address: {
      street: "Amsterdamsevaart",
      number: 171,
      addition: "",
      city: "Haarlem",
      postalCode: "2032 EK",
      countryCode: "NL",
    },
    contactEmail: "head-office@demo.workplaced.com",
    parkingCount: 42,
    visible: true,
    order: 0,
    centerLat: 0,
    centerLng: 0,
    proximityRadius: 99,
    timezone: "Europe/Amsterdam",
    visitorReservationEmail: null,
    businessHours: {
      monday: {},
      tuesday: {},
      wednesday: {},
      thursday: {},
      friday: {},
      saturday: {},
      sunday: {},
      exceptions: [],
    },
    _operations: {
      canDelete: false,
      cannotDeleteDescription:
        "Location has associated reservations, maps, notifications or messages",
    },
  },
];
